













































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import {
  getRotationGroups, getRotationList, getGroupVideos, removeRotation, getRotationVideos, VideoGroupPointData, VideoGroupData
} from '@/api/videoDevice/play'
import { namespace } from 'vuex-class'
import { newGuid } from '@/configs/functions'
import { FailedPermission, PagePermissionState, PermissionData } from '@/store/modules/pagePermission'
const PagePermissionModule = namespace('pagePermission')

interface IRotationGroupData {
  Id: number, GroupName: string, RotationId: number, childs: any[]
}
@Component({
  components: {
  }
})
/**视频轮播 */
export default class RotationList extends Vue {
  @PagePermissionModule.Getter('pagePermission')
  public pagePermission!: PagePermissionState
  public btnCtrl: PermissionData = FailedPermission
  public getPermission() {
    const s = this.pagePermission
    let p = FailedPermission
    if (this.$route.path.indexOf(s.pagePath) > -1) {
      p = s.permission
    }
    this.btnCtrl = p
  }

  @Prop({ default: null })
  public callPlay!: Function

  @Prop({ default: null })
  public hideWnd!: () => void
  @Prop({ default: null })
  public showWnd!: () => void

  public listLoading: boolean = false
  public list: any[] = []
  public queryTerm = {
    Keyword: ''
  }
  public targetId: string = ''
  public created() {
    this.targetId = newGuid()
    this.getPermission()
  }
  public mounted() {
    window.eventBus.$on("submitVideoRotationForm", (info: any) => {
      if (this.targetId = info.targetId) {
        // info.data
        this.fetchData()
      }
    })
  }
  public beforeDestroy() {
    window.eventBus.$off("submitVideoRotationForm")
  }

  //数据加载
  public loadData() {
    //触发控件的查询事件
    this.fetchData()
  }
  public doSearch() {
    this.fetchData()
  }
  public expandKey1: number[] = []
  public expandKey2: number[] = []
  public fetchData() {
    this.expandKey1 = []
    this.expandKey2 = []
    this.listLoading = true
    getRotationList(this.queryTerm).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        this.list = data
        //页面首次加载时，默认打开第一个节点
        if (this.expandKey1.length == 0 && data.length > 0) {
          var row = data[0]
          if (row && row.Id > 0) {
            this.expandKey1 = [row.Id]
            this.fetchGroup(row, null)
          }
        }
      }
      this.listLoading = false
    })
  }
  public fetchGroup(row: any, expandedRows: any) {
    if (!row.childs || row.childs.length == 0) {
      row.childs = []
      row.loading = true
      getRotationGroups(row.Id).then((response: { data: any }) => {
        const data = response.data
        if (data) {
          row.childs = data
          row.loading = false
          var index = this.list.findIndex((v: any) => v.Id == row.Id)
          this.$set(this.list, index, row)
          //页面首次加载时，默认打开第一个分组的监控点
          if (this.expandKey2.length == 0 && data.length > 0) {
            var subRow = data[0]
            if (subRow && subRow.Id > 0) {
              this.expandKey2 = [subRow.Id]
              this.fetchVideo(subRow, null)
            }
          }
        }
      })
    }
  }
  public fetchVideo(row: any, expandedRows: any) {
    if (!row.childs || row.childs.length == 0) {
      row.childs = []
      row.loading = true
      getGroupVideos(row.Id).then((response: { data: any }) => {
        const data = response.data
        if (data) {
          row.childs = data
          row.loading = false

          //强制页面渲染
          //一级索引
          let index1 = this.list.findIndex((v: any) => v.Id == row.RotationId)
          //一级实体
          let rotation = this.list[index1]
          //二级索引
          let index2 = rotation.childs.findIndex((v: any) => v.GroupId == row.Id)
          //更新 二级中的整个子级列表
          this.$set(rotation.childs, index2, row)
          //更新 一级中的单独一项
          this.$set(this.list, index1, rotation)
        }
      })
    }
  }
  public doAdd() {
    var data: any = { id: 0, targetId: this.targetId }
    window.eventBus.$emit("openVideoRotationForm", data)
  }
  public doPlay(index: number) {
    var rot = this.list[index]
    //获取轮播组下的所有视频
    getRotationVideos(rot.Id).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        //#region 按分组插入视频列表
        var groupData: IRotationGroupData[] = []
        data.forEach((e: VideoGroupPointData, i: number) => {
          if (groupData.findIndex((v: IRotationGroupData) => v.Id == e.GroupId) == -1) {
            groupData.push({ Id: e.GroupId, GroupName: e.GroupName, RotationId: rot.Id, childs: [] })
          }
          var g = groupData.find((v: IRotationGroupData) => v.Id == e.GroupId)
          g!.childs.push(e)
        })
        rot.childs = groupData
        //强制页面渲染
        this.$set(this.list, index, rot)
        //#endregion

        //#region 生成视频播放列表
        var groups: { name: string, codes: string[] }[] = []
        var childs = rot.childs
        if (childs && childs.length > 0) {
          childs.forEach((e: any, j: number) => {
            var g: { name: string, codes: string[] } = {
              name: e.GroupName, codes: []
            }
            var points = e.childs
            var codes: any[] = []
            if (points && points.length > 0) {
              points.forEach((p: any, j: number) => {
                codes.push({ code: p.PointNumber, sm: p.StreamMode })
              })
            }
            g.codes = codes
            groups.push(g)
          })
        }
        var count = groups.length
        if (count > 0) {
          if (this.callPlay) {
            var playData: { name: string, min: number, groups: { name: string, codes: string[] }[] } = {
              name: rot.RotationName, min: rot.PlayDuration, groups: groups
            }
            this.callPlay(playData)
          }
        }
        else {
          this.$message.warning('该轮播组下没有视频可以播放')
        }
        //#endregion
      }
    })
  }
  public doEdit(id: number) {
    var data: any = { id: id, targetId: this.targetId }
    window.eventBus.$emit("openVideoRotationForm", data)
  }
  public doDel(id: number) {
    if (this.hideWnd) {
      this.hideWnd()
    }
    this.$confirm(`确定要删除吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      removeRotation(id).then(() => {
        this.$message({ type: 'success', message: '删除成功!' })
        if (this.showWnd) {
          this.showWnd()
        }
        this.fetchData()
      })
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消操作'
      })
      if (this.showWnd) {
        this.showWnd()
      }
    })
  }
  // 在当前路由改变，但是该组件被复用时调用
  @Watch('$route')
  public onRouteChange(route: any) {
  }
}
